import {
  AIUserFeedbackContentType,
  AIUserFeedbackResult,
} from '@dc-shared-web/hooks/api/ai-user-feedback/types'
import { AxiosInstance } from 'axios'

export type GetAIUserFeedbackParams = {
  content_type?: AIUserFeedbackContentType
  content_uuid?: string
  sentiment?: number
  crunch_uuid?: string
  experience_feedback?: string
  improvement_feedback?: string
  sortBy?: string
  sortDirection?: 'ASC' | 'DESC'
  limit?: number
  page?: number
  withDeleted?: boolean
}

export const getAIUserFeedback = async (
  apiClient: AxiosInstance,
  params: GetAIUserFeedbackParams
): Promise<AIUserFeedbackResult> => {
  const { data } = await apiClient.get<AIUserFeedbackResult>(
    '/api/ai-user-feedback',
    {
      params,
    }
  )

  return data
}
